module.exports = __webpack_public_path__ + "static/img/posterProduct1.aac86b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posterProduct1.png
// module id = ALVh
// module chunks = 2